import IntroSlideSelectModal, { INTRO_SLIDE_SELECT_MODAL } from './modal';

export { INTRO_SLIDE_SELECT_MODAL };

export default IntroSlideSelectModal;
